<template>
    <div class="col-sm-12">
        <template v-if="zulp.length > 0">
            <div v-for="z in zulp" class="card-text" :data-testid="'visit-zulp-' + z.id">
                <div class="d-flex justify-content-between border border-light">
                    <!--<div class="p-0 text-secondary" v-if="m.internal">
                        {{ m.operation.code }} <i title="interní výkon" class="fa fa-hand-spock-o text-danger" aria-hidden="true"></i> {{ m.operation.name }}
                    </div>-->
                    <div class="p-0">
                        {{ z.medicine.label }} <span> množství: {{ z.amount }} </span> úhrada: {{ z.insurance_cover_sequence_number }}
                    </div>
                    <div class="p-0">
                        <button v-if="!zulpPending" @click="zulpPending ? null : removeZulp(z.id)" class="btn btn-sm btn-outline-danger" :data-testid="'visit-zulp-delete-' + z.id"><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                        <button class="btn btn-sm btn-outline-danger disabled" v-else=""><i class="fa fa-trash-o" aria-hidden="true"></i></button>
                    </div>
                </div>
            </div>
        </template>
    </div>
</template>

<script>
  import apiMixin from '@/mixins'

  export default {
    data () {
      return {
        waitForResponse: false,
        // zulp: [],
        zulpReload: '',
        zulpPending: false,
        // ZULP DELETE
        deletZulpPending: false,
        deletZulpDone: false,
        deletZulpError: false
      }
    },
    props: ['doUpdate', 'diagnosisId', 'zulp'],
    mixins: [apiMixin],
    methods: {
      /* getActions () {
        this.zulpPending = true
        this.$http.get('/diagnosis/' + this.diagnosisId + '/action').then(response => {
          this.zulp = response.data
          this.zulpPending = false
          this.zulpListUpdated()
        }, response => {
          this.zulp = []
          this.zulpPending = false
        })
      }, */
      updateDiagnosis () {
        this.$emit('update')
      },
      removeZulp (id) {
        this.deleteZulp(id)
      }
    },
    watch: {
      deletZulpDone (val) {
        if (val === true) {
          this.deletZulpPending = false
          this.deletZulpDone = false
          this.deletZulpError = false
          this.$emit('update')
        }
      }
    },
    beforeMount () {
      //
    }
  }
</script>



// WEBPACK FOOTER //
// src/views/Visit/components/ListZulp.vue?4cf095c5